/* ==========================================================================
   RAWTORQUE · FIND PARTS - DESKTOP FITMENT FINDER · v1.0
   On desktop (>=1001px) the "Find Parts" button opens a fitment finder popover
   instead of the catalogue menu. We intercept the click in the CAPTURE phase on
   document, so the theme's own nav-burger handler (bubble phase) never runs -
   the catalogue menu never opens on desktop and the drawer's fixed close button
   never appears. Below 1001px we do nothing: the native mobile drawer + My
   Garage behave exactly as before.

   ROUTING: a chosen vehicle / typed query routes to /search?q=<term>, matching
   the existing "Bike Finder" section. If you later build per-vehicle
   collections, change buildUrl() below to point at them instead.

   DATA: edit BIKE_MODELS (brand -> models) and CARS (brand list) here. These are
   copied from sections/bike-finder.liquid and rt-mobile-drawer.js respectively.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__rtFindParts) return;
  window.__rtFindParts = true;

  var MOBILE_MAX = 1000; // anything <= this keeps the native drawer

  /* ── DATA ─────────────────────────────────────────────────────────── */
  var BIKE_MODELS = {
    'Royal Enfield': ['Interceptor 650','Continental GT 650','Super Meteor 650','Shotgun 650','Bear 650','Classic 350','Meteor 350','Hunter 350','Thunderbird 350','Bullet 350','Himalayan 411','Himalayan 450','Scram 411','Guerrilla 450'],
    'TVS':           ['Apache RTR 160 4V','Apache RTR 200 4V','Apache RR 310','Apache RTX 300','Ronin','Raider 125','Jupiter','Ntorq 125'],
    'Bajaj':         ['Pulsar NS200','Pulsar NS160','Pulsar 220F','Pulsar RS200','Dominar 400','Dominar 250','Avenger 220'],
    'KTM':           ['Duke 125','Duke 200','Duke 250','Duke 390','RC 390','Adventure 390','Adventure 250'],
    'Husqvarna':     ['Svartpilen 250','Vitpilen 250','Svartpilen 401','Vitpilen 401'],
    'Honda':         ['CB350','CB350RS','CB300R','CB300F','Hornet 2.0','X-Blade','Unicorn'],
    'Yamaha':        ['MT-15','R15 V4','FZ-S V3','FZS 25','R3','MT-03'],
    'Suzuki':        ['Gixxer 250','Gixxer SF 250','Gixxer 150','Access 125','Burgman Street']
  };
  var CARS = ['Audi','BMW','Citroen','Ford','Honda','Hyundai','Isuzu','Jeep','Kia','Mahindra','Maruti Suzuki','Mercedes-Benz','MG','Nissan','Renault','Skoda','Tata','Toyota','Volkswagen','Volvo'];

  var POPULAR = [
    { t:'TVS RTX 300', q:'TVS RTX 300' },
    { t:'Classic 350', q:'Classic 350' },
    { t:'Himalayan',   q:'Himalayan' },
    { t:'Honda CB350RS', q:'HONDA CB 350RS' },
    { t:'Duke 390',    q:'Duke 390' },
    { t:'Hunter 350',  q:'Hunter 350' }
  ];

  /* Flat index for free-text search (bikes by model + brand) */
  var SEARCH_INDEX = [];
  Object.keys(BIKE_MODELS).forEach(function (b) {
    BIKE_MODELS[b].forEach(function (m) { SEARCH_INDEX.push({ brand: b, model: m, type: 'bike' }); });
  });
  CARS.forEach(function (b) { SEARCH_INDEX.push({ brand: b, model: b, type: 'car' }); });

  /* ── STATE ────────────────────────────────────────────────────────── */
  var pop, backdrop, trigger = null;
  var state = { type: 'bike', brand: '', model: '' };

  function buildUrl(term) { return '/search?q=' + encodeURIComponent(term); }
  function go(term) { if (term) window.location.href = buildUrl(term); }

  /* ── BUILD POPOVER ────────────────────────────────────────────────── */
  var ICON_BIKE = '<svg viewBox="0 0 24 24" fill="none"><circle cx="5.5" cy="17.5" r="2.5" stroke="currentColor" stroke-width="1.6"/><circle cx="18.5" cy="17.5" r="2.5" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 17.5L8 11l5 .5 3-4 2.5 2.5M14 11.5l1 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_CAR  = '<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="9" width="20" height="10" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M5 9l2-4h10l2 4" stroke="currentColor" stroke-width="1.6"/><circle cx="7.5" cy="19" r="1.5" fill="currentColor"/><circle cx="16.5" cy="19" r="1.5" fill="currentColor"/></svg>';
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function build() {
    if (document.getElementById('rt-finder-pop')) return;

    backdrop = document.createElement('div');
    backdrop.id = 'rt-finder-backdrop';
    document.body.appendChild(backdrop);

    pop = document.createElement('div');
    pop.id = 'rt-finder-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Find parts for your ride');

    var chips = POPULAR.map(function (c) {
      return '<a class="rt-fp__chip" href="' + buildUrl(c.q) + '">' + c.t + '</a>';
    }).join('');

    pop.innerHTML =
      '<div class="rt-fp__card">' +
        '<div class="rt-fp__head">' +
          '<span class="rt-fp__eyebrow">Fitment Search</span>' +
          '<span class="rt-fp__title">Find parts for <b>your ride</b></span>' +
        '</div>' +
        '<div class="rt-fp__seg" role="tablist">' +
          '<button type="button" class="rt-fp__seg-btn is-active" data-type="bike">' + ICON_BIKE + 'Bike</button>' +
          '<button type="button" class="rt-fp__seg-btn" data-type="car">' + ICON_CAR + 'Car</button>' +
        '</div>' +
        '<div class="rt-fp__row">' +
          '<div class="rt-fp__dd" data-dd="brand">' +
            '<button type="button" class="rt-fp__dd-trigger"><span class="rt-fp__dd-lbl">Select brand</span><i class="rt-fp__dd-arr"></i></button>' +
            '<div class="rt-fp__dd-list" role="listbox"></div>' +
          '</div>' +
          '<div class="rt-fp__dd is-disabled" data-dd="model">' +
            '<button type="button" class="rt-fp__dd-trigger"><span class="rt-fp__dd-lbl">Select model</span><i class="rt-fp__dd-arr"></i></button>' +
            '<div class="rt-fp__dd-list" role="listbox"></div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="rt-fp__go" disabled>' + ICON_SEARCH + 'Find parts</button>' +
        '<div class="rt-fp__or"><span>or</span></div>' +
        '<div class="rt-fp__search">' +
          ICON_SEARCH.replace('<svg', '<svg class="rt-fp__search-ico"') +
          '<input type="search" class="rt-fp__search-inp" placeholder="Type your bike or car\u2026" autocomplete="off">' +
          '<div class="rt-fp__sugg" role="listbox"></div>' +
        '</div>' +
        '<div class="rt-fp__pop"><span class="rt-fp__pop-lbl">Popular</span>' + chips + '</div>' +
        '<a class="rt-fp__all" href="/collections/all">Browse full catalogue \u2192</a>' +
      '</div>';

    document.body.appendChild(pop);
    wire();
    renderBrands();
  }

  /* ── DROPDOWN RENDERING ───────────────────────────────────────────── */
  function ddEl(which) { return pop.querySelector('.rt-fp__dd[data-dd="' + which + '"]'); }
  function setLabel(which, text, filled) {
    var dd = ddEl(which);
    dd.querySelector('.rt-fp__dd-lbl').textContent = text;
    dd.classList.toggle('has-val', !!filled);
  }
  function closeAllDD() { pop.querySelectorAll('.rt-fp__dd.is-open').forEach(function (d) { d.classList.remove('is-open'); }); }

  function renderBrands() {
    var list = ddEl('brand').querySelector('.rt-fp__dd-list');
    var brands = state.type === 'car' ? CARS : Object.keys(BIKE_MODELS);
    list.innerHTML = brands.map(function (b) {
      return '<div class="rt-fp__opt' + (state.brand === b ? ' is-sel' : '') + '" data-val="' + b + '">' + b + '</div>';
    }).join('');
  }
  function renderModels(brand) {
    var dd = ddEl('model');
    var list = dd.querySelector('.rt-fp__dd-list');
    var models = BIKE_MODELS[brand] || [];
    list.innerHTML = models.map(function (m) {
      return '<div class="rt-fp__opt" data-val="' + m + '">' + m + '</div>';
    }).join('');
    dd.classList.remove('is-disabled');
  }

  function refreshGo() {
    var ok = state.type === 'car' ? !!state.brand : (!!state.brand && !!state.model);
    pop.querySelector('.rt-fp__go').disabled = !ok;
  }

  /* car brand "Maruti Suzuki" etc. is the search term as-is */
  function submitVehicle() {
    if (state.type === 'car') { if (state.brand) go(state.brand); }
    else { if (state.model) go(state.model); }
  }

  /* ── WIRING ───────────────────────────────────────────────────────── */
  function wire() {
    /* segmented toggle */
    pop.querySelectorAll('.rt-fp__seg-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.type === state.type) return;
        pop.querySelectorAll('.rt-fp__seg-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.type = btn.dataset.type;
        state.brand = ''; state.model = '';
        closeAllDD();
        setLabel('brand', 'Select brand', false);
        setLabel('model', state.type === 'car' ? 'Not required' : 'Select model', false);
        ddEl('model').classList.add('is-disabled');
        ddEl('model').style.display = state.type === 'car' ? 'none' : '';
        renderBrands();
        refreshGo();
      });
    });

    /* dropdown open/close */
    pop.querySelectorAll('.rt-fp__dd').forEach(function (dd) {
      dd.querySelector('.rt-fp__dd-trigger').addEventListener('click', function (e) {
        e.stopPropagation();
        if (dd.classList.contains('is-disabled')) return;
        var wasOpen = dd.classList.contains('is-open');
        closeAllDD();
        if (!wasOpen) dd.classList.add('is-open');
      });
    });

    /* brand pick */
    ddEl('brand').querySelector('.rt-fp__dd-list').addEventListener('click', function (e) {
      var opt = e.target.closest('.rt-fp__opt'); if (!opt) return;
      state.brand = opt.dataset.val; state.model = '';
      setLabel('brand', state.brand, true);
      ddEl('brand').classList.remove('is-open');
      if (state.type === 'bike') {
        setLabel('model', 'Select model', false);
        renderModels(state.brand);
      }
      refreshGo();
    });

    /* model pick */
    ddEl('model').querySelector('.rt-fp__dd-list').addEventListener('click', function (e) {
      var opt = e.target.closest('.rt-fp__opt'); if (!opt) return;
      state.model = opt.dataset.val;
      setLabel('model', state.model, true);
      ddEl('model').classList.remove('is-open');
      refreshGo();
    });

    /* go */
    pop.querySelector('.rt-fp__go').addEventListener('click', submitVehicle);

    /* free-text search */
    var inp = pop.querySelector('.rt-fp__search-inp');
    var sugg = pop.querySelector('.rt-fp__sugg');
    var hl = -1;

    function items() { return sugg.querySelectorAll('.rt-fp__sugg-item'); }
    inp.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase(); hl = -1;
      if (q.length < 2) { sugg.classList.remove('is-open'); sugg.innerHTML = ''; return; }
      var res = SEARCH_INDEX.filter(function (x) {
        return x.model.toLowerCase().indexOf(q) !== -1 || x.brand.toLowerCase().indexOf(q) !== -1;
      }).slice(0, 8);
      if (!res.length) { sugg.classList.remove('is-open'); sugg.innerHTML = ''; return; }
      sugg.innerHTML = res.map(function (x) {
        var term = x.type === 'car' ? x.brand : x.model;
        return '<div class="rt-fp__sugg-item" data-term="' + term + '"><span class="rt-fp__sugg-brand">' + x.brand + '</span>' + x.model + '</div>';
      }).join('');
      sugg.classList.add('is-open');
    });
    sugg.addEventListener('mousedown', function (e) {
      var it = e.target.closest('.rt-fp__sugg-item'); if (!it) return;
      e.preventDefault(); go(it.dataset.term);
    });
    inp.addEventListener('keydown', function (e) {
      var its = items();
      if (e.key === 'ArrowDown') { e.preventDefault(); hl = Math.min(hl + 1, its.length - 1); its.forEach(function (x, i) { x.classList.toggle('is-hl', i === hl); }); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); hl = Math.max(hl - 1, -1); its.forEach(function (x, i) { x.classList.toggle('is-hl', i === hl); }); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (hl >= 0 && its[hl]) go(its[hl].dataset.term);
        else { var v = inp.value.trim(); if (v) go(v); }
      } else if (e.key === 'Escape') { sugg.classList.remove('is-open'); }
    });

    /* close dropdowns / suggestions when clicking elsewhere inside the popover */
    pop.addEventListener('click', function (e) {
      if (!e.target.closest('.rt-fp__dd')) closeAllDD();
      if (!e.target.closest('.rt-fp__search')) sugg.classList.remove('is-open');
    });

    /* chips & catalogue link close the popover naturally via navigation */
  }

  /* ── OPEN / CLOSE / POSITION ──────────────────────────────────────── */
  function position() {
    if (!trigger || !pop) return;
    var r = trigger.getBoundingClientRect();
    var w = pop.offsetWidth || 360;
    var left = Math.min(r.left, window.innerWidth - w - 12);
    left = Math.max(12, left);
    pop.style.top = Math.round(r.bottom + 8) + 'px';
    pop.style.left = Math.round(left) + 'px';
  }

  function open(fromTrigger) {
    build();
    trigger = fromTrigger;
    position();
    pop.classList.add('is-open');
    backdrop.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onEsc);
    window.addEventListener('scroll', position, { passive: true });
    window.addEventListener('resize', onResize);
  }

  function close() {
    if (!pop) return;
    pop.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    closeAllDD();
    var s = pop.querySelector('.rt-fp__sugg'); if (s) s.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onEsc);
    window.removeEventListener('scroll', position);
    window.removeEventListener('resize', onResize);
  }

  function isOpen() { return pop && pop.classList.contains('is-open'); }
  function onEsc(e) { if (e.key === 'Escape') close(); }
  function onResize() {
    if (window.innerWidth <= MOBILE_MAX) { close(); return; } // dropped to mobile -> let native drawer own it
    position();
  }

  backdropClose();
  function backdropClose() {
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (e.target.closest('#rt-finder-pop')) return;
      if (e.target.closest('a[aria-controls="nav"]')) return; // handled by intercept below
      close();
    });
  }

  /* ── DESKTOP INTERCEPT (capture phase) ────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= MOBILE_MAX) return;        // mobile: native drawer untouched
    var a = e.target.closest('a[aria-controls="nav"]'); // the Find Parts button(s)
    if (!a) return;
    e.preventDefault();
    e.stopImmediatePropagation();                       // stop theme's nav-burger (bubble phase)
    if (isOpen()) close(); else open(a);
  }, true);

  /* keyboard activation (space) of the Find Parts button on desktop */
  document.addEventListener('keyup', function (e) {
    if (window.innerWidth <= MOBILE_MAX) return;
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var a = e.target.closest && e.target.closest('a[aria-controls="nav"]');
    if (!a) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (isOpen()) close(); else open(a);
  }, true);
})();